import { AuthGuardService } from '@core/auth/auth-guard.service';
import { OtherLayoutComponent } from '@layouts/other-layout/other-layout.component';
import { NotFoundComponent } from '@components/not-found/not-found.component';
import { MainLayoutComponent } from '@layouts/main-layout/main-layout.component';
import { AuthLayoutComponent } from '@layouts/auth-layout/auth-layout.component';
import { LayoutComponent } from '@layouts/layout/layout.component';
import { B2bMainLayoutComponent } from '@layouts/b2b-main-layout/b2b-main-layout.component';
import System, { SYSTEM } from '@shared/constants/system';
import { TrainingVideoModule } from '@routes/training-video/training-video.module';

const hb = import('./hb/hb.module');
const auth = import('./auth/auth.module');
const sample = import('./sample/sample.module');
const users = import('./users/users.module');
const dealers = import('./dealers/dealers.module');
const products = import('./products/products.module');
const tickets = import('./tickets/tickets.module');
const mobiles = import('./mobile/mobile.module');
const summary = import('./summary/summary.module');
const concealedDamage = import('./concealed-damage/concealed-damage.module');
const trainingVideo = import('./training-video/training-video.module');
const payments = import('./payments/payments.module');
const purchasePlace = import('./purchase-place/purchase-place.module');

const b2b = import('./b2b/b2b.module');

const defaultRoutes = [
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      { path: 'auth', loadChildren: () => auth.then(m => m.AuthModule) },
    ]
  }, {
    path: '',
    component: OtherLayoutComponent,
    children: [
      { path: 'error', component: NotFoundComponent },
    ]
  }, {
    path: '**', pathMatch: 'full', component: NotFoundComponent
  }
];

const dealerRoutes = [
  {
    path: 'training-video',
    component: LayoutComponent,
    children: [
      { path: '', loadChildren: () => trainingVideo.then(m => m.TrainingVideoModule) },
    ]
  },
  {
    path: 'concealed-damage',
    canActivate: [
      AuthGuardService,
    ],
    component: LayoutComponent,
    children: [
      { path: '', loadChildren: () => concealedDamage.then(m => m.ConcealedDamageModule) },
    ]
  }, {
    path: '',
    canActivate: [
      AuthGuardService,
    ],
    component: MainLayoutComponent,
    children: [
      { path: '', loadChildren: () => summary.then(m => m.SummaryModule) },
      { path: 'tickets', loadChildren: () => tickets.then(m => m.TicketsModule) },
      { path: 'users', loadChildren: () => users.then(m => m.UsersModule) },
      { path: 'dealers', loadChildren: () => dealers.then(m => m.DealersModule) },
      { path: 'payments', loadChildren: () => payments.then(m => m.PaymentsModule) },
      { path: 'purchase-place', loadChildren: () => purchasePlace.then(m => m.PurchasePlaceModule) },
    ]
  }, {
    path: '',
    component: OtherLayoutComponent,
    children: [
      { path: 'mobile', loadChildren: () => mobiles.then(m => m.MobileModule) },
      { path: 'hb', loadChildren: () => hb.then(m => m.HbModule) },
    ]
  },
];

const b2bRoutes = [
  {
    path: '',
    canActivate: [
      AuthGuardService,
    ],
    component: B2bMainLayoutComponent,
    children: [
      { path: '', loadChildren: () => b2b.then(m => m.B2bModule) },
    ]
  }, {
    path: '',
    component: OtherLayoutComponent,
    children: [
      { path: 'hb', loadChildren: () => hb.then(m => m.HbModule) },
    ]
  },
]

let routes = [];

if (System.getSystem() !== SYSTEM.B2B) {
  routes = [
    ...dealerRoutes,
    ...defaultRoutes,
  ];
} else {
  routes = [
    ...b2bRoutes,
    ...defaultRoutes,
  ];
}

export { routes };
